module.exports = __webpack_public_path__ + "static/media/historico.9d70f1f3.svg";